var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Teleport',{attrs:{"to":"body"}},[_c('div',{staticClass:"pdf_computing_content"},[_c('div',{staticClass:"loading_principal"},[_c('Loading',{attrs:{"label":_vm.$store.state.ui.screenPdfOn == 'scale' ? _vm.$t('pdf_computing') : _vm.$t('png_computing')}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }